// Central marketplace economics for NContro.
// Change these values in ONE place — they propagate to the terms pages and the
// booking checkout breakdown.

export const MARKETPLACE = {
  deposit_percent: 25,          // % of quoted total due at acceptance
  balance_due_days: 7,          // balance due N days before event
  platform_fee_percent: 12,     // NContro platform fee
  vendor_payout_percent: 88,    // 100 - platform_fee_percent
  processing_fee_usd: 50,       // flat refund processing fee
  currency: "USD",
  version: "1.0",
  effective_date: "February 1, 2026",
};

// Cancellation windows (days_before_event, refund_of_deposit_percent, note)
export const CANCELLATION_TIERS = [
  { min_days: 60, refund_percent: 100, note: "Full deposit refund, minus a $50 processing fee." },
  { min_days: 30, refund_percent: 50,  note: "50% of the deposit refunded." },
  { min_days: 14, refund_percent: 25,  note: "25% of the deposit refunded." },
  { min_days: 0,  refund_percent: 0,   note: "Deposit is non-refundable within 14 days of the event." },
];

// Helpers for the live booking breakdown
export function computeBreakdown(total) {
  const t = Number(total) || 0;
  const deposit = +(t * MARKETPLACE.deposit_percent / 100).toFixed(2);
  const balance = +(t - deposit).toFixed(2);
  const platform_fee = +(t * MARKETPLACE.platform_fee_percent / 100).toFixed(2);
  const vendor_payout = +(t - platform_fee).toFixed(2);
  return { total: t, deposit, balance, platform_fee, vendor_payout };
}

export function formatUSD(n) {
  const v = Number(n) || 0;
  return v.toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 2 });
}
